/* global PRODUCTION */

import Logger from './utils/logger/Logger';

const type = (PRODUCTION) ? 'prod' : 'dev';
const logger = new Logger(type);

export default logger;
